"use strict";
angular.module('infoAlertModule', []).
controller('infoAlertCtrl', infoAlertCtrl);
infoAlertCtrl.$inject = ["$scope", "$modalInstance", "infoAlertParams", "$compile", "$validation", "trsHttpService", "trsspliceString", "modalDialog"];

function infoAlertCtrl($scope, $modalInstance, infoAlertParams, $compile, $validation, trsHttpService, trsspliceString, modalDialog) {

    $scope.data = {
        infoData: infoAlertParams.params
    }

    function isEmptyObject(obj) {
        for (var key in obj) {
            return true; //
        }
        return false; 
    }

    $scope.data.showApp=isEmptyObject($scope.data.infoData.APP)
    $scope.data.showWebsite=isEmptyObject($scope.data.infoData.WEBSITE)
    /**
     * [close description] 关闭
     */
    $scope.close = function() {
        // $modalInstance.dismiss();
        $modalInstance.close("success");
    };
}